// extracted by mini-css-extract-plugin
export default {"presentation":"Presentation_presentation__44xvv","backdrop":"Presentation_backdrop__P4+cC","content":"Presentation_content__eNiAQ"};